var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("email-verification-banner", {
        class: {
          widget: _vm.addWidgetClass,
          "app-standalone": _vm.$route.name === "application-page",
        },
        attrs: {
          id: "email-veriFication-banner",
          "side-right": _vm.isSideBarVisible,
        },
      }),
      _vm._v(" "),
      _c("router-view", {
        class: { "has-banner": !_vm.EMAIL_VERIFIED },
        on: { showSidebar: _vm.handleToggle },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }